import { useLingui } from "@lingui/react/macro";
import { Link } from "@tanstack/react-router";

import { Button } from "@/shared/ui/button";

import type { DrillsOverview } from "../../model/Drill";
import { TopicGrid } from "./TopicGrid";

type CaughtUpProps = { overview: DrillsOverview };

// Задач сейчас нет: всё решено, темы с ошибкой ждут завтрашнего повтора.
export const CaughtUp = ({ overview }: CaughtUpProps) => {
  const { t } = useLingui();
  return (
    <div className="flex flex-col gap-5">
      <section className="flex flex-wrap items-center justify-between gap-x-6 gap-y-3.5 rounded-2xl border border-border bg-surface px-6 py-5">
        <div className="flex min-w-0 flex-[1_1_380px] flex-col gap-1">
          <h1 className="font-display text-[32px] leading-tight">{t`That's all for today`}</h1>
          <p className="text-sm text-muted">
            {t`The tasks from your analyses are solved. Topics you missed come back tomorrow. New tasks appear after your next analysis.`}
          </p>
        </div>
        <Button asChild size="lg" className="min-h-12 px-6 no-underline">
          <Link to="/">{t`Analyze a match`}</Link>
        </Button>
      </section>
      <TopicGrid topics={overview.topics} />
    </div>
  );
};
